import { Check } from "lucide-react";
import { toast } from "sonner";
import { VEHICLES } from "@/lib/boyCourier";
import { cn } from "@/lib/utils";
import { NextBtn, StepHead } from "./StepBar";
import { VehicleIcon } from "./VehicleIcon";

function Option({ v, on, onPick }) {
  return (
    <button type="button" role="radio" aria-checked={on} onClick={onPick} data-testid={`boy-vehicle-${v.id}`}
      className={cn("flex items-center gap-4 rounded-xl border-2 p-4 text-left transition-[border-color,background-color,transform] duration-200 active:scale-[0.98]",
        on ? "border-primary bg-primary/5" : "border-border hover:border-primary/40")}>
      <span className={cn("flex h-12 w-12 shrink-0 items-center justify-center rounded-xl transition-colors", on ? "bg-primary text-primary-foreground" : "bg-muted")}>
        <VehicleIcon id={v.id} className="h-6 w-6" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-semibold">{v.label}</span>
        <span className="block text-sm text-muted-foreground">{v.hint}</span>
      </span>
      <span className={cn("flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2", on ? "border-primary bg-primary text-primary-foreground" : "border-muted-foreground/40")}>
        {on && <Check className="h-3 w-3" />}
      </span>
    </button>
  );
}

export function StepVehicle({ f, patch, onNext }) {
  const go = (e) => {
    e.preventDefault();
    if (!f.vehicle) return toast.error("Escolha o veículo");
    onNext();
  };
  return (
    <form onSubmit={go} className="space-y-5" data-testid="boy-step-vehicle">
      <StepHead title="Como você quer fazer suas entregas?" text="Escolha o veículo que você vai usar no dia a dia. Você poderá mudar isso depois se precisar." />
      <div className="grid gap-3" role="radiogroup">
        {VEHICLES.map((v) => <Option key={v.id} v={v} on={f.vehicle === v.id} onPick={() => patch({ vehicle: v.id })} />)}
      </div>
      <NextBtn disabled={!f.vehicle} testid="boy-step-vehicle-next">Confirmar Veículo</NextBtn>
    </form>
  );
}
